import React, { useState } from "react";
import LdsButton from "../../components/LdsButton";
// import { SideBar } from "../../components/SideBar";
// import { useSelector } from "react-redux";

import LdsTile from "../../components/LdsTile";
import LdsFigureCaption from "../../components/LdsFigureCaption";
import LdsVideoPlayer from "../../components/LdsVideoPlayer";
import { Formik, Form, Field } from "formik";
import cx from "classnames";
// import LdsRadio from "../../components/LdsRadio";
import LdsKalturaPlayer from "../LdsVideoPlayer/KalturaPlayer";

import {
  useSaveAnswereMutation,
  useGetTrainingMenuBasedOnModuleQuery,
} from "../../store/services/moduleServerApi";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
var showStep3 = "p-4 mt-5 mb-5 module-step-3";
// var answerHighlightCorrect = "ms-4 d-inline-bolck answer";
// var answerHighlightIncorrect = "ms-4 d-inline-bolck answer";
var answerDefault = "ms-4 d-inline-bolck answer";
var formSubmitted = false;
var nextButtonLock = true;
// var correctAnswer = "";
// var incorrectAnswer = "";
// var assessmentName = "";
// var videoTranscript = "";
// var nextLesson = "";
// var videoId = "";
// var previousLesson = "";
// var iframeURL = "";
// var letter = "";
var correctLetter = "";
var answerHighlightRed = "ms-4 d-inline-bolck answer";
var answerHighlightGreen = "ms-4 d-inline-bolck answer";

var incorrect_a = "ms-4 d-inline-bolck answer";
var incorrect_b = "ms-4 d-inline-bolck answer";

function getChallenge(assessment_name, type) {
  if (type == "assessment") {
    let xhr = new XMLHttpRequest();
    // cors https://cors-anywhere.herokuapp.com/
    xhr.open(
      "GET",
      "https://dev.amyvid.hibbertreader.com/lillyOrtService/api/v1/core/mim/cloud",
      true
    );
    xhr.send(null);
    xhr.onload = function () {
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status === 200) {
          let data = JSON.parse(this.responseText);
          window.open(
            "mim:--cloudlicense%20ag9zfm1pbS1jbG91ZC1ocmRyFgsSDENsb3VkQWNjb3VudBiTl-DWCQw%20--licenses%20107%20--nopl%20--clear%20--src%20CLOUD%20AmyvidTraining@AmyvidTraining.com%20--pname%20" +
              assessment_name +
              "%20--jsoncreds%20" +
              data.tokenId +
              "%20" +
              data.decryptionKey,
            "_self"
          );
        } else {
          console.log(
            "There is no response from the server. Please try again."
          );
        }
      }
    };
  } else {
    let xhr = new XMLHttpRequest();
    // cors https://cors-anywhere.herokuapp.com/
    xhr.open(
      "GET",
      "https://dev.amyvid.hibbertreader.com/lillyOrtService/api/v1/core/mim/cloud",
      true
    );
    xhr.send(null);
    xhr.onload = function () {
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status === 200) {
          let data = JSON.parse(this.responseText);
          window.open(
            "mim:--cloudlicense%20ag9zfm1pbS1jbG91ZC1ocmRyFgsSDENsb3VkQWNjb3VudBiTl-DWCQw%20--licenses%20107%20--nopl%20--clear%20--src%20CLOUD%20AmyvidTraining@AmyvidTraining.com%20--sessionid%20" +
              assessment_name +
              '%20--advsearch%20{"Params":[{"Tag":"PatientName","Operator":"regex","Value":"%5E' +
              assessment_name +
              '%24"}]}%20--jsoncreds%20' +
              data.tokenId +
              "%20" +
              data.decryptionKey,
            "_self"
          );
        } else {
          console.log(
            "There is no response from the server. Please try again."
          );
        }
      }
    };
  }
}

function disableAnswerButton() {
  const answerElement = document.getElementById("submitAnswer");
  const answerSelect = document.getElementById("answerSelect");

  answerElement.disabled = true;
  answerSelect.disabled = true;
}

const Module_Question = (props) => {
  // MIM auto-login API
  const [state, setState] = useState({
    isActiveClassCorrect: false,
    isActiveClassIncorrect: false,
  });

  // call the service
  const [saveAnswere, { status }] = useSaveAnswereMutation();

  if (status === "fulfilled") {
  }

  const saveResponseToserver = (data) => {
    saveAnswere(data);
  };

  const addCorrect = (letter, nextLesson) => {
    setState({ isActiveClassCorrect: true });
    showStep3 = cx("p-4 mt-5 mb-5 module-step-3 correct");
    answerHighlightGreen = cx("ms-4 d-inline-bolck answer green b");
    //answerHighlightRed= cx('ms-4 d-inline-bolck answer');
    nextButtonLock = false;
    answerDefault = "ms-4 d-inline-bolck answer green";

    disableAnswerButton();
    const elements = document.getElementById("next");
    if (elements) {
      elements.disabled = false;
      elements.classList.remove("disabled");
      elements.addEventListener("click", function (e) {
        window.open(nextLesson, "_self");
      });
    }
  };

  const correctTextBuild = () => {
    if (props.correctAnswer === "A") {
      return "You answered incorrectly. Please view the video below for an explanation of why this is a positive case before you move on to the next case.";
    } else {
      return "You answered incorrectly. Please view the video below for an explanation of why this is a negative case before you move on to the next case.";
    }
  };

  const addIncorrect = () => {
    setState({ isActiveClassIncorrect: true });
    showStep3 = cx("p-4 mt-5 mb-5 module-step-3 incorrect");
    answerHighlightGreen = cx("ms-4 d-inline-bolck answer");
    answerHighlightRed = cx("ms-4 d-inline-bolck answer red b");
    nextButtonLock = true;
    disableAnswerButton();
    answerDefault = "ms-4 d-inline-bolck answer red";
  };

  const navClick = (link) => {
    window.open(link, "_self");
  };

  const radioClick = () => {
    const elements = document.getElementById("submitAnswer");
    elements.disabled = false;
    elements.classList.remove("disabled");
  };

  const correctMarkerClassName = cx("correct col-sm-12 d-inline-bolck", {
    show: state.isActiveClassCorrect,
  });
  const inCorrectMarkerClassName = cx("incorrect col-sm-12 d-inline-bolck", {
    show: state.isActiveClassIncorrect,
  });

  return (
    <div className="row">
      <section>
        <div className="row">
          <div className="col col-md-8">
            <LdsTile
              ariaLabel="Question 1"
              className="p-4 mt-5 mb-5"
              role="region"
            >
              <LdsTile.Body className="mb-4">
                <h2 className="h3 b">Step 1</h2>
                <p>
                  Please click this{" "}
                  <a
                    className="orange b clickable-link"
                    onClick={() =>
                      getChallenge(props.assessmentName, props.questionType)
                    }
                  >
                    link to review {props.assessmentName}
                  </a>{" "}
                  in MIM Referring or click on{" "}
                  <span className=" b">{props.assessmentName}</span> in Mobile
                  MIM if using an iPad. Review the case, return to this screen,
                  and indicate whether the scan is positive or negative.
                </p>
              </LdsTile.Body>
            </LdsTile>
            <LdsTile ariaLabel="Step 2" className="p-4 mt-5 mb-5" role="region">
              <LdsTile.Body className="mb-4 row module-step-2">
                <div className="d-flex justify-content-center align-items-center mb-4"></div>
                <h2 className="h3 b">Step 2</h2>
                <Formik
                  initialValues={{
                    scan: "",
                  }}
                  onSubmit={async (values) => {
                    await sleep(500);
                    console.log("props.correctAnswer", props.correctAnswer);
                    let answer;
                    //alert(JSON.stringify(values, null, 2));
                    if (props.correctAnswer == values.scan) {
                      // Sets disabled to false to allow next without video
                      addCorrect(values.scan, props.nextLesson);

                      correctLetter = values.scan;
                      formSubmitted = true;
                      console.log("Correct");
                      console.log(values.scan);
                      answer = "Correct";
                    } else {
                      addIncorrect(values.scan);
                      formSubmitted = true;
                      console.log("Inorrect");
                      console.log(values.scan);
                      correctLetter = values.scan;
                      answer = "Incorrect";
                    }

                    // save answer to server
                    saveResponseToserver({
                      pathName: window.location.pathname,
                      selectedOption: correctLetter,
                      answer,
                    });
                  }}
                >
                  {({ isSubmitting }) => (
                    <>
                      <Form>
                        <fieldset
                          role="radiogroup"
                          className="row"
                          id="answerSelect"
                        >
                          {" "}
                          <legend>Is the scan positive or negative?</legend>
                          {/* Answer should change color to green or red depending on correct response. */}
                          <div className="col-sm-12">
                            <Field
                              type="radio"
                              name="scan"
                              value="A"
                              id="positive"
                              onClick={() => radioClick()}
                            />
                            <label
                              for="positive"
                              className={
                                correctLetter === "A"
                                  ? answerDefault + " correct"
                                  : answerDefault + incorrect_a
                              }
                            >
                              A. Positive
                            </label>
                          </div>
                          <div className="col-sm-12">
                            <Field
                              type="radio"
                              name="scan"
                              value="B"
                              id="negative"
                              onClick={() => radioClick()}
                            />
                            <label
                              for="negative"
                              className={
                                correctLetter === "B"
                                  ? answerDefault + " correct"
                                  : answerDefault + incorrect_b
                              }
                            >
                              B. Negative
                            </label>
                          </div>
                        </fieldset>

                        <button
                          id="submitAnswer"
                          type="submit"
                          disabled={true}
                          className="orange-button mt-5 mb-5 disabled"
                        >
                          Submit Your Answer
                        </button>
                      </Form>
                      <div className="row">
                        <span
                          id="correct_statement"
                          className={correctMarkerClassName}
                        >
                          <svg
                            className="lds-icon check-circle-fill inline"
                            aria-hidden="true"
                            role="img"
                            focusable="false"
                          >
                            <title>Question Correct</title>
                          </svg>
                          &nbsp;<span className="ps-1 b">Correct!</span>
                        </span>
                        <span
                          id="incorrect_statement"
                          className={inCorrectMarkerClassName}
                        >
                          <svg
                            className="lds-icon x-circle-fill inline"
                            aria-hidden="true"
                            role="img"
                            focusable="false"
                          >
                            <title>Question Incorrect</title>
                          </svg>
                          &nbsp;<span className="ps-1 b">Incorrect!</span>
                        </span>
                      </div>
                    </>
                  )}
                </Formik>
              </LdsTile.Body>
            </LdsTile>
            <LdsTile ariaLabel="Step 3" className={showStep3} role="region">
              <LdsTile.Body className="mb-4 row">
                <h2 className="h3 b">Step 3</h2>
                <p className={inCorrectMarkerClassName}>{correctTextBuild()}</p>
                <p className={correctMarkerClassName}>
                  You answered correctly. Please view the optional video below
                  for further information on the scan.
                </p>

                <LdsFigureCaption
                  textContent={props.videoTranscript}
                  buttonIcon="MinusCircle"
                  buttonTextAlign="left"
                  showDescriptionText="Video Transcript"
                  hideDescriptionText="Video Transcript"
                  radiusSize="small"
                >
                  <LdsVideoPlayer
                    aspectRatio="16/9"
                    brandBorder={false}
                    heading=""
                  >
                    <LdsKalturaPlayer
                      videoId={props.videoId}
                      partnerId="1759891"
                      uiConfId="54959122"
                      nextUrl={props.nextLesson}
                    />
                  </LdsVideoPlayer>
                </LdsFigureCaption>
              </LdsTile.Body>
            </LdsTile>
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              href={props.previousLesson}
              onClick={() => navClick(props.previousLesson)}
              aria-label="Previous Lesson"
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              id="next"
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              disabled={true}
              aria-label="Next Lesson"
            >
              Next Lesson
            </LdsButton>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Module_Question;
